export const valueFormatter = ({value, colDef, node}) => {
  let {match_label = true, mismatch_label = false} = colDef.cellRendererParams.original.computed_match_settings;

  return (
    (node?.group || node?.data?.childCount) && value == undefined ?
      null :
      value == null || value == undefined
        ? `${I18n.t('calculating')}...`
        : value
          ? match_label
          : mismatch_label
  );
};
